import { StoreConfig } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/store_config_pb'
import React from 'react'

type Props = {
  storeConfig: StoreConfig
}

export const BookerEventHeaderPolicy = ({ storeConfig }: Props) => {
  return (
    <div className="flex flex-col gap-4 ">
      {!!storeConfig.bookingPolicy && (
        <div
          dangerouslySetInnerHTML={{
            __html: storeConfig.bookingPolicy.replace(/\n/g, '<br />'),
          }}
        />
      )}
    </div>
  )
}
